import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { ExperimentIds } from "../commons/constants/experiment";
import { useAdsenseContext } from "../adsense/AdsenseContext";
import { isControlCohort } from "./helper";

// https://godaddy-corp.atlassian.net/browse/PARKING-4283
export function useSkenzoLander() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, dbKey, cohort } = {} } = landerConfig;
  const { hasAdsense } = useAdsenseContext();

  const inExperiment =
    key === ExperimentIds.skenzoLander &&
    hasAdsense === false &&
    dbKey === "PARKING-4283";
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);

  useEffect(() => {
    if (!inExperiment) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: {
        inTreatmentCohort,
      },
    });
  }, [inExperiment, landerConfigDispatch, inTreatmentCohort]);

  if (inExperiment && inTreatmentCohort) {
    return true;
  }
  return false;
}
